import type { ButtonHTMLAttributes } from "react"
import Spinner from "@/components/Spinner/Spinner"
import styles from "@/styles/components/Button.module.css"

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "quiet"
  size?: "default" | "bar"
  /**
   * A write is in flight: shows the spinner and refuses further presses.
   *
   * Disabled as well as marked, because everything behind one of these buttons
   * is a Firestore round trip — a second press either creates a second document
   * or lands as a no-op nobody can tell apart from the first press failing.
   */
  loading?: boolean
}

export default function Button({
  variant = "primary",
  size = "default",
  loading = false,
  disabled = false,
  className,
  type = "button",
  children,
  ...rest
}: ButtonProps) {
  const classes = [styles.button, styles[variant], styles[size], className]
    .filter(Boolean)
    .join(" ")
  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <Spinner /> : null}
      {children}
    </button>
  )
}
